
export default {
  name: 'MFooter'
}
